/* 아코디언 토글 — 카페24 `care_detail.html` 의 스크립트를 옮긴 것.
   케어(`neoteria-care`)와 스펙(`neoteria-*-specs`)이 함께 쓴다.
   ⚠️ 스코프 클래스는 `.nt-toggle` 이다 — 토글을 쓰는 섹션의 바깥 래퍼에 붙여야 동작한다.
   원본을 FTP 로 받아(`/sde_design/skin148/hs/html/product/detail/care_detail.html`) 그대로 이식했다.

   하는 일 셋:
     1) 클릭·키보드(Enter/Space)로 `is_open` 토글
     2) **같은 행 좌우 패널의 펼친 높이를 통일**(`--pair-h`) 후 실제 높이를 px 로 주입(`--body-h`)
     3) 펼치면 그 패널이 화면 중앙에 오도록 스크롤(내용이 화면보다 크면 제목을 상단에)

   ⚠️ `--body-h` 를 px 로 주는 이유: CSS 가 `grid-template-rows: 0px → var(--body-h)` 로 전환한다.
      `0fr → 1fr` 로 하면 fr 보간이 픽셀 기준 제곱 곡선이라 여는 중간에 확 열린다(카페24 실측 주석).
   ⚠️ 재기 전에 `--pair-h` 를 지운다 — 그게 inner 의 min-height 라 측정값을 오염시킨다.
      `--body-h` 는 grid 트랙이라 scrollHeight 에 영향이 없어 지우지 않는다(지웠다 넣으면 트랙이 튄다).
   ⚠️ 모바일에서는 컬럼이 `display: contents` 라 `offsetTop` 이 0 이 된다 — 스택 여부는
      좌표가 아니라 `matchMedia` 로 판별해야 한다(카페24가 같은 함정을 주석으로 남겼다).
   ⚠️ Shopify 는 섹션을 다시 그리므로 `shopify:section:load` 에서 재계산한다(카페24에 없는 부분). */
(function () {
  /* ⚠️⚠️ **중복 실행 가드 — 지우지 말 것.** 이 파일은 토글을 쓰는 섹션마다 `<script src>` 로
     불리므로 한 페이지에 태그가 여러 개 생긴다(스펙 + 케어 = 2개). 같은 URL 이어도 브라우저는
     **태그마다 실행**하기 때문에, 가드가 없으면 클릭 리스너가 두 번 등록돼 한 번 누를 때
     `toggle()` 이 두 번 돌고 **열렸다 즉시 닫힌다**(실측: fayfay-s-blue 에서 아예 안 열렸다.
     스크립트가 하나뿐인 fayfay-leopard 에서는 멀쩡해서 처음 검증을 통과했다).
     ⚠️ 카페24 원본에도 같은 가드가 있었다(`window.__detailToggleInit`) — 옮기며 빠뜨렸다.
     ⚠️ 첫 실행의 `initAll()` 이 페이지의 `.nt-toggle` 을 **전부** 초기화하므로 뒤 태그가
        건너뛰어도 빠지는 섹션은 없다. 나중에 붙는 섹션은 `shopify:section:load` 가 받는다. */
  if (window.__ntToggleInit) return;
  window.__ntToggleInit = true;

  var OPEN = 'is_open';
  var MOBILE_MQ = '(max-width: 1024px)';

  function setOpen(wrap, open) {
    var title = wrap.querySelector(':scope > .toggle_title');
    wrap.classList.toggle(OPEN, open);
    if (title) title.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function scopeOf(el) {
    return el.closest('.nt-toggle');
  }

  function children(el, selector) {
    return Array.prototype.filter.call(el.children, function (c) {
      return c.matches(selector);
    });
  }

  /* 같은 행 좌우 패널 높이 통일 + 펼침 높이 주입 */
  function equalizePairs(root) {
    var wraps = Array.prototype.slice.call(root.querySelectorAll('.toggle_item_wrap'));
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      wrap.style.removeProperty('--pair-h');
    });

    var ownHeights = wraps.map(function (wrap) {
      var inner = wrap.querySelector(':scope > .toggle_body > .toggle_body_inner');
      return inner ? inner.scrollHeight : 0;
    });

    var columns = Array.prototype.slice.call(root.querySelectorAll('.toggle_column'));
    var isStacked = window.matchMedia && window.matchMedia(MOBILE_MQ).matches;

    if (columns.length >= 2 && !isStacked) {
      var rows = columns.map(function (col) {
        return children(col, '.toggle_item_wrap');
      });
      var depth = Math.max.apply(
        null,
        rows.map(function (col) {
          return col.length;
        })
      );

      for (var i = 0; i < depth; i++) {
        var pair = rows
          .map(function (col) {
            return col[i];
          })
          .filter(Boolean);
        if (pair.length < 2) continue;

        var tallest = Math.max.apply(
          null,
          pair.map(function (wrap) {
            return ownHeights[wraps.indexOf(wrap)] || 0;
          })
        );
        pair.forEach(function (wrap) {
          wrap.style.setProperty('--pair-h', tallest + 'px');
        });
      }
    }

    wraps.forEach(function (wrap, idx) {
      var pairH = parseFloat(wrap.style.getPropertyValue('--pair-h')) || 0;
      wrap.style.setProperty('--body-h', Math.max(pairH, ownHeights[idx]) + 'px');
    });
  }

  /* 펼친 뒤 놓일 스크롤 위치. 펼침이 끝나기를 기다리지 않고 최종 높이(--body-h)로 미리 계산해
     펼침과 스크롤이 함께 진행되게 한다(패널 자기 위치는 펼치는 동안 변하지 않는다). */
  function targetScrollTop(wrap) {
    var body = wrap.querySelector(':scope > .toggle_body');
    if (!body) return null;

    var titleEl = wrap.querySelector(':scope > .toggle_title');
    var rect = body.getBoundingClientRect();
    var titleH = titleEl ? titleEl.getBoundingClientRect().height : 0;
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var offset = window.pageYOffset || document.documentElement.scrollTop;
    var finalH = parseFloat(wrap.style.getPropertyValue('--body-h')) || rect.height;

    /* 고정 크롬(공지 바 + 헤더)만큼 위를 비운다. 카페24는 #beltBanner + #header_wrap_outer 였다. */
    var bar = document.querySelector('.announcement-bar-section');
    var header = document.querySelector('.section-header');
    var chrome =
      (bar ? bar.clientHeight : 0) + (header ? header.clientHeight : 0);

    var top;
    if (finalH + titleH * 2 >= viewport) {
      /* 내용이 화면보다 크면 중앙 정렬이 제목을 화면 밖으로 밀어낸다 — 제목을 위에 붙인다. */
      top = offset + (titleEl || body).getBoundingClientRect().top - 100;
    } else {
      top = offset + rect.top - chrome - (viewport - finalH) / 2;
    }
    return Math.max(0, Math.round(top));
  }

  function smoothScrollTo(top) {
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    } catch (err) {
      window.scrollTo(0, top);
    }
  }

  function scrollWhileExpanding(wrap) {
    var top = targetScrollTop(wrap);
    if (top === null) return;

    var body = wrap.querySelector(':scope > .toggle_body');
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    /* 페이지 끝 패널이면 문서가 아직 덜 자라 목표까지 못 내려간다 — 그때만 펼침 후 한 번 보정. */
    var clamped = top > document.documentElement.scrollHeight - viewport;

    smoothScrollTo(top);
    if (!clamped) return;

    var done = false;
    function correct() {
      if (done) return;
      done = true;
      body.removeEventListener('transitionend', onEnd);
      if (!wrap.classList.contains(OPEN)) return;
      var retry = targetScrollTop(wrap);
      if (retry !== null && Math.abs(window.scrollY - retry) > 2) smoothScrollTo(retry);
    }
    function onEnd(e) {
      if (e.target === body && e.propertyName === 'grid-template-rows') correct();
    }
    body.addEventListener('transitionend', onEnd);
    setTimeout(correct, 450); /* transition 0.35s — transitionend 누락 대비 */
  }

  function toggle(title) {
    var wrap = title.closest('.toggle_item_wrap');
    if (!wrap) return;
    var root = scopeOf(wrap);
    if (!root) return;
    var willOpen = !wrap.classList.contains(OPEN);
    equalizePairs(root); /* 열기 직전에 현재 레이아웃으로 다시 잰다 */
    setOpen(wrap, willOpen);
    /* ⚠️ 푸터처럼 화면 맨 아래 있는 토글은 열 때 스크롤을 옮기지 않는다 — 카페24 푸터도
       `slideToggle` 만 하고 화면을 움직이지 않는다. `data-nt-noscroll` 로 끈다. */
    if (willOpen && !root.hasAttribute('data-nt-noscroll')) scrollWhileExpanding(wrap);
  }

  function findTitle(target) {
    if (!target || !target.closest) return null;
    var title = target.closest('.toggle_title');
    if (!title || !scopeOf(title)) return null; /* 이 섹션 밖은 건드리지 않는다 */
    return title;
  }

  document.addEventListener('click', function (e) {
    var title = findTitle(e.target);
    if (title) toggle(title);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var title = findTitle(e.target);
    if (!title) return;
    e.preventDefault();
    toggle(title);
  });

  var timer;
  function scheduleAll() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      markJoined();
      mergeJoined();
      document.querySelectorAll('.nt-toggle').forEach(equalizePairs);
    }, 100);
  }

  function init(root) {
    root.querySelectorAll('.toggle_item_wrap').forEach(function (wrap) {
      setOpen(wrap, false);
    });
    equalizePairs(root);

    root.querySelectorAll('.toggle_columns img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', scheduleAll, { once: true });
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(scheduleAll);
      root.querySelectorAll('.toggle_columns').forEach(function (el) {
        ro.observe(el);
      });
    }
  }

  /* 토글 섹션이 연달아 오면 위 섹션의 닫는 선과 아래 섹션의 여는 선이 2px 로 겹친다.
     카페24는 네 패널이 한 컨테이너라 그 자리에 선이 하나뿐이다 — 뒤 섹션에 표시를 달아
     CSS 가 첫 줄의 위쪽 선을 지우게 한다.
     ⚠️ CSS 만으로는 판단할 수 없다(두 토글이 각자 `<section>` 안에 있어 인접 형제가 아니다).
     ⚠️ 상품마다 앞 섹션이 비어 사라지기도 하므로(스펙 데이터가 없는 상품) 고정 설정이 아니라
        **화면에 실제로 무엇이 있는지** 보고 정해야 한다. */
  function markJoined() {
    var prevWasToggle = false;
    document.querySelectorAll('main [id^="shopify-section"]').forEach(function (sec) {
      var t = sec.querySelector('.nt-toggle');
      var visible = t && t.getBoundingClientRect().height > 0;
      if (visible) t.classList.toggle('nt-toggle--joined', prevWasToggle);
      if (t) prevWasToggle = visible;
      else if (sec.getBoundingClientRect().height > 0) prevWasToggle = false;
    });
  }

  /* ⚠️⚠️ 이어진 토글 섹션의 패널을 **앞 섹션의 같은 컬럼으로 옮긴다.**
     카페24는 네 패널이 한 컨테이너라 **컬럼이 서로 독립**이다 — TECH(좌 위)를 열면
     EYEWEAR(좌 아래)만 내려가고 SPORTS(우 아래)는 제자리다(실측으로 확인).
     섹션이 둘로 나뉘어 있으면 뒤 섹션이 통째로 밀려 그 동작이 안 나온다.
     ⚠️ CSS 로는 불가능하다 — 두 토글이 각자 `<section>` 안이라 같은 flex 컨테이너에 못 들어간다.
     ⚠️ 옮긴 뒤에는 `.nt-toggle--joined` 의 선 처리도 필요 없다(한 컬럼이 되어 자연히 1겹).
     ⚠️ 옮긴 패널은 원래 섹션의 `.wrapper-{id}` 스코프를 벗어나므로 그쪽 색·크기 설정을 잃고
        앞 섹션 설정을 따른다. 두 섹션의 제목 색·크기를 다르게 두면 이 지점에서 갈린다.
     ⚠️ 컬럼 수가 다르면 옮기지 않는다(짝을 맞출 수 없다). */
  function mergeJoined() {
    /* ⚠️⚠️ **Theme Editor 에서는 병합하지 않는다.** 에디터는 편집한 섹션을 통째로 새 DOM 으로
       갈아끼우는데, 앞 섹션이 교체되면 그 안으로 옮겨 둔 뒤 섹션의 패널이 **함께 사라진다**
       (실측: 스펙 섹션을 다시 그리자 케어 두 패널이 없어졌다. 새로고침하면 돌아오지만
       편집 중에 콘텐츠가 사라져 보이는 건 나쁘다).
       에디터에서는 두 섹션이 원래대로 아래위에 놓인다 — 위치는 같고, 한쪽을 열었을 때
       반대쪽 컬럼이 밀리는지만 다르다. 실제 화면에서는 병합되어 카페24와 같이 움직인다. */
    if (window.Shopify && window.Shopify.designMode) return;

    var toggles = Array.prototype.filter.call(
      document.querySelectorAll('.nt-toggle'),
      function (t) {
        return t.getBoundingClientRect().height > 0 || t.querySelector('.toggle_item_wrap');
      }
    );

    for (var i = 1; i < toggles.length; i++) {
      var cur = toggles[i];
      if (cur.classList.contains('nt-toggle--merged')) continue;
      if (!cur.classList.contains('nt-toggle--joined')) continue;

      var prevCols = toggles[i - 1].querySelectorAll('.toggle_columns > .toggle_column');
      var curCols = cur.querySelectorAll('.toggle_columns > .toggle_column');
      if (!prevCols.length || prevCols.length !== curCols.length) continue;

      var fromId = cur.closest('[id^="shopify-section"]');
      fromId = fromId ? fromId.id : '';
      Array.prototype.forEach.call(curCols, function (col, k) {
        Array.prototype.slice.call(col.children).forEach(function (wrap) {
          /* ⚠️ 출처를 남긴다 — Theme Editor 가 **그 섹션만** 새 DOM 으로 갈아끼우면
             여기 옮겨 둔 옛 패널은 남아 있어 그대로 두면 같은 패널이 두 벌이 된다. */
          wrap.dataset.ntFrom = fromId;
          prevCols[k].appendChild(wrap);
        });
      });
      cur.classList.add('nt-toggle--merged');
      toggles[i - 1].classList.remove('nt-toggle--joined');
    }
  }

  function initAll() {
    markJoined();
    mergeJoined();
    /* 옮긴 뒤에 초기화해야 짝 높이가 **합쳐진 컬럼 기준**으로 계산된다. */
    document.querySelectorAll('.nt-toggle').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  window.addEventListener('load', scheduleAll); /* 이미지 로드 후 재계산 */
  window.addEventListener('resize', scheduleAll);
  /* Theme Editor 가 섹션을 다시 그리면 옮겨 뒀던 패널이 원래 자리로 돌아온다 —
     ⚠️ `init` 만 부르면 병합이 풀린 채로 남는다. 전체를 다시 판정·병합해야 한다.
     ⚠️ `initAll` 은 `markJoined` → `mergeJoined` → `init` 순서라 그대로 부르면 된다. */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    /* 다시 그려진 섹션에서 옮겨 왔던 옛 패널을 먼저 걷는다. 새 DOM 이 같은 패널을
       들고 오므로 그대로 두면 두 벌이 된다. */
    var reloaded = e.target.id;
    if (reloaded) {
      document.querySelectorAll('[data-nt-from="' + reloaded + '"]').forEach(function (w) {
        w.remove();
      });
    }
    document.querySelectorAll('.nt-toggle--merged').forEach(function (t) {
      t.classList.remove('nt-toggle--merged');
    });
    initAll();
  });
})();
